import React, { useContext } from "react";
import axios from "axios";
import { useLocation, withRouter } from "react-router-dom";
import queryString from "query-string";

function determinePubHubBaseUrl() {
  const hostname = window.location.hostname;
  if (/localhost/.test(hostname)) {
    return "http://localhost:3000";
    // return 'https://dev.pubhub.studio';
  } else if (/admin-dev/.test(hostname)) {
    return "https://dev.pubhub.studio";
  } else if (/admin-test/.test(hostname)) {
    return "https://test.pubhub.studio";
  } else if (/admin-prep/.test(hostname)) {
    return "https://prep.pubhub.studio";
  } else if (/admin./.test(hostname)) {
    return "https://pubhub.studio";
  }
}

const API = () => {
  const query = queryString.parse(window.location.search);
  let authToken = window.localStorage.getItem("authToken") || null;
  if (query && query.jwt !== undefined) {
    authToken = query.jwt;
  }
  const phUrl = determinePubHubBaseUrl();

  const apiInstance = axios.create({
    baseURL: phUrl,
    timeout: 120000,
    headers: {
      Authorization: `Bearer ${authToken}`
    },
  });

  const get = async ({ params, url, signal }) => {
    try {
      const response = await apiInstance.get(url, {
        signal,
        params: params,
        method: "get",
      });
      if (response.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (response.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (error?.response?.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return error;
      }
    }
  };
  const postFile = async ({ params, data, url }) => {
    // const response = await apiInstance.post(url, data, {
    //   headers: {
    //     'Content-Type': 'multipart/form-data'
    //   }
    // });
    const response = await axios.post(url, data, {
      baseURL: phUrl,
      timeout: 600000,
      headers: {
        "Content-Type": "multipart/form-data",
        // 'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${authToken}`
      },
    });
    if (response.status === 401 || response.status === 403) {
      // window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      console.log("response", response);
    } else {
      return response.data;
    }
  };
  const post = async ({ params, data, url }) => {
    try {
      const response = await apiInstance.post(url, {
        params: params,
        method: "post",
        ...data,
      });
      if (response.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (response.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (error?.response?.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return error;
      }
    }
  };

  const put = async ({ data, url }) => {
    try {
      const response = await apiInstance.put(url, {
        ...data,
        method: "put",
      });
      if (response.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (response.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (error?.response?.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return error;
      }
    }
  };

  const del = async ({ data, url }) => {
    try {
      const response = await apiInstance.delete(url, {
        ...data,
        method: "delete",
      });
      if (response.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (response.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return response.data;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        window.location.replace(`${determinePubHubBaseUrl()}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (error?.response?.status === 403) {
        window.location.replace(`${determinePubHubBaseUrl()}/learningcentres`);
      } else {
        return error;
      }
    }
  };

  return {
    get: get,
    post: post,
    postFile: postFile,
    put: put,
    delete: del,
    phUrl: phUrl
  };
};

export default withRouter(API());
